// extracted by mini-css-extract-plugin
module.exports = {"image":"ProductBox_image__2G6Bh","image-compact":"ProductBox_image-compact__2Y80l","image-container":"ProductBox_image-container__2f5uu"};